import Vue from 'vue'
import Main from './main'

const PopCtor = Vue.extend(Main)
const hasOwnProperty = Object.prototype.hasOwnProperty

let instance

const Notification = function(options = {}) {
  if (Vue.prototype.$isServer) return
  if (typeof options === 'string') {
    options = {
      message: options
    }
  } else {
    options = { ...options }
  }
  const { message } = options
  const id = `notification_tip`
  options.isInComp = false

  if (isVNode(message)) {
    instance.$slots.default = [message]
    options.message = 'REPLACED_BY_VNODE'
  }

  if (instance) {
    instance.destroyElement()
  }

  instance = new PopCtor({
    propsData: options
  })

  instance.$mount()
  instance.$el.id = id
  document.body.appendChild(instance.$el)
}

Notification.cancel = () => {
  instance.destroyElement()
}

function isVNode(node) {
  return (
    node !== null &&
    typeof node === 'object' &&
    hasOwnProperty.call(node, 'componentOptions')
  )
}

export default Notification
